@if (data.title) {
  <h2 class="dialog-title" mat-dialog-title>{{ data.title }}</h2>
}
@if (data.listItems?.length) {
  <span class="dialog-message" mat-dialog-title>
    {{data.message}}
  </span>
}
<mat-dialog-content>
  <div class="mgd-dialog-content-container dialog-content">  
    @if (data.listItems?.length) {
      <div class="confirmation-list-items">
        <mat-list role="list">
          @for (item of data.listItems; track item.text) {
            <mat-list-item role="listitem">
              @if (item.imageUrl) {
                  <img class="item-image" matListItemAvatar [src]="item.imageUrl" [alt]="item.text">
              }
              <div class="item-text" matListItemLine>{{ item.text }}</div>
            </mat-list-item>
          }
        </mat-list>
      </div>
    }
    @else {
      {{ data.message }}
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions class="confirmation-actions">
  <button class="cancel-button" mgdButton mat-raised-button matDialogClose [disableWhileProcessing]="false">{{ data.cancelButtonText }}</button>
  <button mat-raised-button (click)="onConfirmClick()" mgdButton mgdButtonType="save" class="confirm-button" cdkFocusInitial [disableWhileProcessing]="false">{{ data.confirmationButtonText }}</button>
</mat-dialog-actions>
